import { HttpMethod } from '@vision/ui/enums';
import { TicketManagerApiRequest } from '../ticket-manager.api';

const TICKET_MANAGER_INNER_LOOP_ENDPOINT = '/v2/inner_loop';

interface TicketManagerTicketCreateCommentRequestDto {
  body: string;
}

export const buildTicketManagerTicketCommentsRequest = ({
  projectId,
  ticketId,
}: {
  projectId: string;
  ticketId: string;
}): TicketManagerApiRequest => ({
  method: HttpMethod.GET,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/tickets/${ticketId}/comments`,
});

export const buildTicketManagerTicketCreateCommentRequest = ({
  body,
  projectId,
  ticketId,
}: {
  body: string;
  projectId: string;
  ticketId: string;
}): TicketManagerApiRequest => {
  const data: TicketManagerTicketCreateCommentRequestDto = {
    body,
  };

  return {
    data,
    method: HttpMethod.POST,
    url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/tickets/${ticketId}/comments`,
  };
};

export const buildTicketManagerTicketDeleteCommentRequest = ({
  commentId,
  projectId,
  ticketId,
}: {
  commentId: string;
  projectId: string;
  ticketId: string;
}): TicketManagerApiRequest => ({
  method: HttpMethod.POST,
  url: `${TICKET_MANAGER_INNER_LOOP_ENDPOINT}/${projectId}/tickets/${ticketId}/comments/${commentId}/delete`,
});
